
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 3a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5V1h-5V.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5V1H3V.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v2a.5.5 0 00.5.5H1v5H.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5H1v5H.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V18h5v.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V18h5v.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5H18v-5h.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5H18V3h.5zM17 1h1v1h-1V1zM9 1h1v1H9V1zM1 1h1v1H1V1zm0 8h1v1H1V9zm1 9H1v-1h1v1zm8 0H9v-1h1v1zm8 0h-1v-1h1v1zm0-8h-1V9h1v1zm-1-2h-.5a.5.5 0 00-.5.5v2a.5.5 0 00.5.5h.5v5h-.5a.5.5 0 00-.5.5v.5h-5v-.5a.5.5 0 00-.5-.5h-2a.5.5 0 00-.5.5v.5H3v-.5a.5.5 0 00-.5-.5H2v-5h.5a.5.5 0 00.5-.5v-2a.5.5 0 00-.5-.5H2V3h.5a.5.5 0 00.5-.5V2h5v.5a.5.5 0 00.5.5h2a.5.5 0 00.5-.5V2h5v.5a.5.5 0 00.5.5h.5v5z","fill":"#515358","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/toolbars/select.svg